import {
    Box,
    Grid,
    Hidden,
    InputAdornment,
    Paper,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
    IconButton,
    Menu,
    MenuItem,
    Button
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Search } from "@material-ui/icons";
import GetAppIcon from '@material-ui/icons/GetApp';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EmptyImg from "assets/images/empty-folder.png";
import React from "react";
import CustomTable from "./tableContent";
import CustomTableMobile from "./tableContentMobile";
import { API_ROOT } from "constants/actionTypes";
import { downloadBlob, getBlob } from "components/public-dashboard/services/api_util";
const useStyles = makeStyles((theme) => ({
  searchField: {
    float: "right",
    marginBottom: 5,
    marginRight: 5,
  },
  topBar: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: 5,
  },
  exportButton: {
    textTransform: "none",
  },
}));
export default function Table(props) {
  const {
    totalItems,
    handleNavUpdate,
    handleQueryUpdate,
    handleFetch,
    query,
    searchEnabled = false,
    emptyMessage = "No transactions found. Try changing the filter.",
    excelExportUrl,
    csvExportUrl,
  } = props;
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.down("xs"));

  const [searchValue, setSearchValue] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
    handleQueryUpdate({ ...query, searchTerm: event.target.value });
    handleFetch();
  };

  const handleExportClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setAnchorEl(null);
  };

  const handleExcelExport = async () => {
    setAnchorEl(null);
    const url = `${API_ROOT}${excelExportUrl}${searchValue ? `?searchTerm=${encodeURIComponent(searchValue)}` : ''}`;
    const response = await getBlob(url);
    if (response.state === 1) {
      downloadBlob(response.data, "Agent_Locations.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    }
  };

  const handleCSVExport = async () => {
    setAnchorEl(null);
    const url = `${API_ROOT}${csvExportUrl}${searchValue ? `?searchTerm=${encodeURIComponent(searchValue)}` : ''}`;
    const response = await getBlob(url);
    if (response.state === 1) {
      downloadBlob(response.data, "Agent_Locations.csv", "text/csv");
    }
  };

  const classes = useStyles();

  return (
    <Box>
      {(searchEnabled || excelExportUrl || csvExportUrl) && (
        <Box className={classes.topBar}>
          {(excelExportUrl || csvExportUrl) && (
            <>
              <Button
                variant="outlined"
                color="secondary"
                className={classes.exportButton}
                startIcon={<GetAppIcon />}
                endIcon={<ExpandMoreIcon />}
                onClick={handleExportClick}
              >
                Export
              </Button>
              <Menu
                id="export-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleExportClose}
              >
                <MenuItem onClick={handleExcelExport}>Excel</MenuItem>
                <MenuItem onClick={handleCSVExport}>CSV</MenuItem>
              </Menu>
            </>
          )}
          {searchEnabled && (
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
              variant="standard"
              value={searchValue}
              onChange={handleSearchChange}
              placeholder="Search…"
              color="secondary"
            />
          )}
        </Box>
      )}
      {totalItems > 0 ? (
        <Grid container spacing={xs ? 1 : 3}>
          <Hidden xsDown>
            <Grid item xs={12}>
              <CustomTable {...props} searchValue={searchValue} />
            </Grid>
          </Hidden>
          <Hidden smUp>
            <Grid item xs={12}>
              <CustomTableMobile {...props} searchValue={searchValue} />
            </Grid>
          </Hidden>
        </Grid>
      ) : (
        <Paper>
          <Box p={3}>
            <Grid
              container
              direction="column"
              justify="space-between"
              alignItems="center"
              spacing={5}
            >
              <Grid item xs={12} style={{ opacity: 0.5 }}>
                <img
                  src={EmptyImg}
                  alt="empty folder icon"
                  style={{ height: 128 }}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" style={{ textAlign: "center" }}>
                  {emptyMessage}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      )}
    </Box>
  );
}
